<template lang="pug">
  v-footer(v-if="isShowMessage" padless fixed)
    v-card.card-message
      p.message.text-center Для улучшения работы сайта, повышения его эффективности и удобства мы используем cookie файлы. Продолжая использовать сайт outstaff.bls-soft.ru, вы даете согласие на использование cookie файлов.
      v-btn.bnt-style.text-none.justify-center(@click="saveToken") Принять и продолжить
</template>

<script>
import cookies from 'vue-cookie'

export default {
  name: "CookieMessage",
  data () {
    return {
      cookies,
      isShowMessage: true
    }
  },
  methods: {
    saveToken () {
      this.cookies.set('cookieconsent_status', 'dismiss', 365)
      this.isShowMessage = false
    }
  }
}
</script>

<style scoped lang="sass">
  @import "scss/variables.scss"
  @import "scss/colors.scss"

  @media(max-width: $xsOnly)
    .message
      font-size: 13px

    .bnt-style
      font-size: 14px

  @media(min-width: $smAndUp)
    .message
      font-size: 14px

    .bnt-style
      font-size: 16px

  .card-message
    width: 100%
    height: auto
    justify-content: center
    align-content: center
    padding: 1em 1.8em
    background-color: $backgroundContainer
    .message
      margin-left: $marginMax
      margin-right: $marginMax
      line-height: 1.5em
      margin-top: 7px
      display: block
      text-align: center
      font-family: GothamProClassic

    .bnt-style
      justify-content: center !important
      margin-left: auto
      margin-right: auto
      margin-bottom: 12px
      elevation: 0
      display: flex
      letter-spacing: 0.01em
      color: $white
      font-family: RobotoRegular,sans-serif
      background: $btnColor

</style>